// extracted by mini-css-extract-plugin
module.exports = {"nav-buttons":"teaser-buttons_nav-buttons__4zmro","next":"teaser-buttons_next__lqB_0","previous":"teaser-buttons_previous__zWhTY"};